import { FC } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useSpecificCounterparty } from "../../dataHooks/counterpartyQueries";
import { useIsMobileLayout } from "../../../../layout/useIsMobileLayout";
import { MergerChip } from "../../../../components/mergerChip";

type Props = {};
type Params = {
  id: string;
};

// Mounted under /tradingcounterparties and /mergers, so the sign-off page is detected from the
// path's tail rather than from one absolute pattern.
export const CounterpartyMenu: FC<Props> = () => {
  const params = useParams<Params>();
  const { pathname } = useLocation();

  const { data } = useSpecificCounterparty(params.id);

  const name = data?.counterpartyName ?? "";
  const onSignOff = /\/signoff\/?$/.test(pathname);
  const isMobile = useIsMobileLayout();

  return (
    <Box
      sx={{
        marginLeft: 2,
        minWidth: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        gap: 1.5
      }}
    >
      <Typography
        variant={isMobile ? "h6" : "h5"}
        noWrap
        sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {onSignOff ? `Sign off: ${name}` : name}
      </Typography>
      {data?.isMerger && <MergerChip size={isMobile ? "small" : "medium"} />}
    </Box>
  );
};
